<!--
 * @Description: 
 * @Author: 
 * @Date: 2021-11-18 17:51:20
 * @LastEditTime: 2022-09-09 09:12:00
 * @LastEditors: jq.lian
 * @Usage: 
-->
<template>
  <div id="HeadTop">
    <div class="top">
      <div class="logo">
        <img
          v-if="userInfo.platFormLogo"
          :src="userInfo.platFormLogo"
        />
        <h6>{{userInfo.platFormName}}</h6>
      </div>
      <ul class="right">
        <li v-if="placeName">
          <img :src="locationImg" />
          <span style="margin-left: 5px;">{{placeName}}</span>
        </li>
        <li class="user">
          {{userInfo.userType == 2 ? '公司管理员' : userInfo.userType == 4 ? '项目管理员' :  userInfo.account }}：{{userInfo.account}}
        </li>
        <li @click="logout">
          <img
            src="../assets/img/switch.png"
            title="退出登录"
          />
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { regionData, CodeToText, TextToCode } from "element-china-area-data";

import { setStore, getStore } from '@/util/store';
const SUPER_ADMIN = 1; // 超级管理员 jky2021  666666
const COMPANY_ADMIN = 2; // 公司管理员(公司用户跳转到选择公司列表，然后进首页) 前端专用 666666
const BRANCH_COMPANY_ADMIN = 3; // 分公司管理员
const PROJECT_ADMIN = 4; // 项目管理员 前端项目 666666
const UNIT_ADMIN = 5; // 参建单位管理员（跳转到后台，和项目权限一样，去掉参建单位tab） 参建单位 666666
const THIRD_PART_ADMIN = 6; // 第三方管理员(和参建单位一样)
const COMPANY_USER = 7; // 公司人员
const PROJECT_USER = 8; // 项目人员
const UNIT_USER = 9; // 参建单位人员
const THIRD_PART_USER = 10; // 第三方人员
const other_USER = 11; // 其他人员
export default {
  name: 'HeadTop',
  data() {
    return {
      locationImg: require('../assets/img/location.png'),
      imgUrl: require('../assets/img/switch.png'),
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      const userType = getStore({ name: 'userType' })
      if (userType == COMPANY_ADMIN || userType == BRANCH_COMPANY_ADMIN || userType == PROJECT_ADMIN) {
        this.$store.dispatch('getCompanyInfo')
      }
    },
    logout() {
      setStore({ name: 'projectId', content: '' })
      setStore({ name: 'companyId', content: '' })
      setStore({ name: 'account', content: '' })
      setStore({ name: "accessToken", content: '' });

      this.$store.commit('setUserInfo', {});
      this.$store.commit('setCompanyInfo', {})
      this.$router.push({ path: "/" });
    }
  },
  computed: {
    ...mapState(["companyInfo", "userInfo"]),
    placeName() {
      // 直辖市
      if (this.userInfo.provinceName == this.userInfo.cityName && (this.userInfo.provinceName)) {
        return this.userInfo.provinceName + this.userInfo.areaName
      } else { // 其他省份
        return this.userInfo.provinceName + this.userInfo.cityName
      }
    },
  },
}
</script>

<style lang="scss" scoped>
#HeadTop {
  // position: relative;
  // top:0;
  // left:0;
  // right:0;
  // z-index:100;
  .top {
    padding: 0 20px;
    box-shadow: 0px 2px 0px 0px #114d85;
    background: #09216b;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .logo {
      display: flex;
      justify-content: flex-start;
      img {
        height: 70px;
      }
      h6 {
        font-size: 34px;
        display: inline-block;
        padding-left: 18px;
        border-left: 2px solid #335175;
        margin: 0;
        height: 40px;
        line-height: 40px;
        color: #55d8ff;
        margin-top: 10px;
        padding-top: 0;
      }
    }
    .right {
      height: 100%;
      li {
        display: inline-block;
        color: #fff;
        font-weight: bold;
        font-size: 20px;
        margin-left: 10px;
        cursor: pointer;
      }
      .user {
        border-left: 1px solid #335175;
        margin-left: 20px;
        padding-left: 10px;
      }
    }
  }
}
</style>
